import React, { FC } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { OilsFilterProps } from './types/OilsFIlter.types';
import './OilsFilter.scss';

import TitleWithFilters from './components/TitleWithFilters/TitleWithFilters';
import OilsContainer from './components/OilsContainer/OilsContainer';

const OilsFilter: FC<OilsFilterProps> = ({
  fields: {
    Title,
    Countries,
    CountryLabel,
    CountryPlaceHolder,
    ApplicationLabel,
    ApplicationPlaceHolder,
    SubApplicationLabel,
    SubApplicationPlaceHolder,
    SeriesLabel,
    SeriesPlaceHolder,
    HomologationLabel,
    HomologationPlaceHolder,
    GetNextFilter,
    FilterItem,
  },
  sitecoreContext,
}) => (
  <Provider store={store}>
    <div className="OilsFilter">
      <div>
        <TitleWithFilters
          title={Title}
          countriesOptions={Countries.flatMap((c) => {
            return c.fields.Countries.map(
              (country)=>{
                  return {
                    id: country.id,
                    name: country.fields.Title.value,
                    countries: [country.fields.CodeNationFromGeoLocalization.value],
                    parentId: c.id
                  }
              }
            )
           
          }).sort((a,b)=>a.name.localeCompare(b.name))}
          queryOptions={{
            getNextFilter: GetNextFilter.value,
            sitename: sitecoreContext.site.name,
            lang: sitecoreContext.language,
            dbName: sitecoreContext.route.databaseName,
            initialFilterItem: FilterItem.id,
          }}
          labels={{
            country: {
              label: CountryLabel.value,
              placeholder: CountryPlaceHolder.value,
            },
            application: {
              label: ApplicationLabel.value,
              placeholder: ApplicationPlaceHolder.value,
            },
            subapplication: {
              label: SubApplicationLabel.value,
              placeholder: SubApplicationPlaceHolder.value,
            },
            series: {
              label: SeriesLabel.value,
              placeholder: SeriesPlaceHolder.value,
            },
            homoAndMiss: {
              label: HomologationLabel.value,
              placeholder: HomologationPlaceHolder.value,
            },
          }}
        />

        <OilsContainer />
      </div>
    </div>
  </Provider>
);

export default withSitecoreContext()(OilsFilter);
